import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MarkNotificationReadMutationVariables = Types.Exact<{
  input: Types.MarkNotificationReadInput;
}>;


export type MarkNotificationReadMutation = { __typename?: 'Mutation', markNotificationRead: { __typename?: 'NotificationPayload', notification?: { __typename?: 'NotificationDocument', id: string, kind: Types.NotificationKind, module: string, entityType: string, entityId: string, createdAt: Types.TDateISO, readAt?: Types.TDateISO | null, fields: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type MarkNotificationUnreadMutationVariables = Types.Exact<{
  input: Types.MarkNotificationUnreadInput;
}>;


export type MarkNotificationUnreadMutation = { __typename?: 'Mutation', markNotificationUnread: { __typename?: 'NotificationPayload', notification?: { __typename?: 'NotificationDocument', id: string, kind: Types.NotificationKind, module: string, entityType: string, entityId: string, createdAt: Types.TDateISO, readAt?: Types.TDateISO | null, fields: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type MarkAllNotificationsReadMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsReadMutation = { __typename?: 'Mutation', markAllNotificationsRead: { __typename?: 'MarkAllNotificationsReadPayload', markedCount: number, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const MarkNotificationReadDocument = new TypedDocumentString(`
    mutation MarkNotificationRead($input: MarkNotificationReadInput!) {
  markNotificationRead(input: $input) {
    notification {
      ...Notification
    }
    errors {
      code
      message
    }
  }
}
    fragment Notification on NotificationDocument {
  id
  kind
  module
  entityType
  entityId
  fields {
    key
    value
  }
  createdAt
  readAt
}`);
export const MarkNotificationUnreadDocument = new TypedDocumentString(`
    mutation MarkNotificationUnread($input: MarkNotificationUnreadInput!) {
  markNotificationUnread(input: $input) {
    notification {
      ...Notification
    }
    errors {
      code
      message
    }
  }
}
    fragment Notification on NotificationDocument {
  id
  kind
  module
  entityType
  entityId
  fields {
    key
    value
  }
  createdAt
  readAt
}`);
export const MarkAllNotificationsReadDocument = new TypedDocumentString(`
    mutation MarkAllNotificationsRead {
  markAllNotificationsRead {
    markedCount
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MarkNotificationRead: build.mutation<MarkNotificationReadMutation, MarkNotificationReadMutationVariables>({
      query: (variables) => ({ document: MarkNotificationReadDocument, variables })
    }),
    MarkNotificationUnread: build.mutation<MarkNotificationUnreadMutation, MarkNotificationUnreadMutationVariables>({
      query: (variables) => ({ document: MarkNotificationUnreadDocument, variables })
    }),
    MarkAllNotificationsRead: build.mutation<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables | void>({
      query: (variables) => ({ document: MarkAllNotificationsReadDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMarkNotificationReadMutation, useMarkNotificationUnreadMutation, useMarkAllNotificationsReadMutation } = injectedRtkApi;
